/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getList.defs.js'
export { main as default } from './getList.defs.js'
